import { Component, OnInit } from '@angular/core';
import {MatchBaseComponent} from '@lib-modules/match/pages/match/match-base/match-base.component';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {IHeaderTickerItem} from '@lib-modules/match/services/match-ticker/match-ticker.service';
import {VideoHeaderContent} from '@modules/game-detail/components/match-video-header/match-video-header.component';
import {IStreamingInfo, LivestreamStatus} from '@api/models/livestream/streaming-info';
import {IVideo, VideoSubType} from '@api/models/video/video';
import {Event} from '@api/models/event/event';
import {TickerItemType} from '@api/models/ticker/ticker-item-type';

@Component({
  selector: 'lib-match-web',
  templateUrl: './match-web.component.html',
  styleUrls: ['../match-base/match-base.component.scss', './match-web.component.scss']
})
export class MatchWebComponent extends MatchBaseComponent implements OnInit {
  public colorScheme = ColorScheme.Dark;
  public videoHeaderContent: VideoHeaderContent;
  private goalHeaderItems: IHeaderTickerItem[] = [];
  private redCardHeaderItems: IHeaderTickerItem[] = [];
  private match: Event;
  protected readonly TickerItemType = TickerItemType;

  async ngOnInit() {
    this.loading = true;
    await super.ngOnInit();
    this.match = this.matchService.match;
    this.goalHeaderItems = this.matchTickerService.goalHeaderItems;
    this.redCardHeaderItems = this.matchTickerService.redCardHeaderItems;
    this.setVideoHeaderContent();
    this.loading = false;
  }

  // Abstract property implementations
  protected subscribeToRouteParams() {
      this.route.paramMap.subscribe(async (paramMap) => {
        const eventId = paramMap.get('eventId');
        const teamId = paramMap.get('teamId');
        await this.reload(eventId, teamId);
      });
  }

  onNavigateToDetail(): void {
  }

  // Video content
  private setVideoHeaderContent() {
    // Youtube
    this.videoHeaderContent = {
      youtubeLivestream: this.match?.videos?.livestreamURL,
      youtubeHighlights: this.match?.videos.highlightsURL
    }

    // Native videos
    const streamInfo = this.match?.streaming_info;
    if (!streamInfo) {
      return;
    }
    this.videoHeaderContent.eventId = this.match._id;
    switch (streamInfo.live_status) {
      case LivestreamStatus.Live:
        this.handleLiveStream(streamInfo);
        break;
      case LivestreamStatus.Cancelled:
        break;
      default:
        this.handleReplayAndHighlights();
    }
  }

  private handleLiveStream(streamInfo: IStreamingInfo) {
    const livestream = {
      bm_player_url: streamInfo.hls_url,
      preview: streamInfo.livestream_preview,
      paywall: streamInfo.paywall,
      liveStream: true
    } as IVideo;

    if (livestream.bm_player_url) {
      this.videoHeaderContent.livestream = livestream;
    }
  }

  private handleReplayAndHighlights() {
    if (!this.match.videos_native) {
      return;
    }
    const replay = this.match.videos_native.find(video => video.subtype === VideoSubType.Replay);
    const highlights = this.match.videos_native.find(video => video.subtype === VideoSubType.Highlight);

    if (replay || highlights) {
      this.videoHeaderContent.replay = replay;
      this.videoHeaderContent.highlights = highlights;
    }
  }

  get showGoals(): boolean {
    return this.goalHeaderItems.length > 0;
  }

  get showRedCards(): boolean {
    return this.redCardHeaderItems.length > 0;
  }

  public getGoalHeaderItems(home: boolean) {
    return this.goalHeaderItems.filter(item => item.home === home);
  }

  public getRedCardHeaderItems(home: boolean) {
    return this.redCardHeaderItems.filter(item => item.home === home);
  }
}
